import {Fragment} from "preact";
import {Dialog, Transition} from "@headlessui/react";
import s from "./selfServiceAttendanceModal.module.css";
import {useSelfServiceAttendanceModal} from "./useSelfServiceAttendanceModal";
import {iconCloseV2, productCartIcon} from "../../assets";
import Content from "./Content";

const SelfServiceAttendanceModal = () => {
    // Component logic data
    const componentProps = useSelfServiceAttendanceModal();

    // Destructured component logic data
    const {
        buttonStyle,
        isSelfServiceAttendanceModalOpen,
        selfServiceAttendanceModalData,
        handleButtonStyle,
        handleClose
    } = componentProps;

    return (
        <Fragment>
            <Transition.Root show={isSelfServiceAttendanceModalOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[20]" onClose={handleClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-fade-modal bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center sm:items-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-700"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-300"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel
                                    className={`font-museo relative z-0 transform overflow-hidden h-screen bg-light-gray text-left shadow-xl transition-all sm:max-w-screen w-screen flex items-start md:items-center`}>
                                    <button
                                        type={"button"}
                                        className={`${s.closeIcon} ${buttonStyle === "light" ? s.lightButton : ""}`}
                                        onClick={() => handleClose()}
                                    >
                                        Fechar
                                        <img
                                            src={iconCloseV2}
                                            alt="Close icon"
                                        />
                                    </button>
                                    <Content
                                        selfServiceAttendanceModalData={selfServiceAttendanceModalData}
                                        handleButtonStyle={handleButtonStyle}
                                        handleClose={handleClose}
                                    />
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    )
}

export default SelfServiceAttendanceModal;
